import React from 'react';
import { Container, Row, Col, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ServerError = () => {
    return (
        <div className="min-vh-100 d-flex align-items-center">
            <Container className="py-5">
                <Row className="justify-content-center text-center">
                    <Col lg={8} md={10} className="px-4">
                        <Card className="card-hover menu-item-card mb-0 mx-auto" >
                            <Card.Body>
                                {/* 500 Illustration */}
                                <div className="position-relative mb-4">
                                    <h1 className="display-1 fw-bold text-danger">500</h1>

                                </div>

                                {/* Error Message */}
                                <h2 className="display-5 fw-bold mb-3">Oops! Server Error</h2>
                                <p className="lead text-muted mb-4">
                                    Something went wrong on our end. Our team has been notified and we're working to fix it.
                                    Please try again later or contact support if the problem persists. 🛠️
                                </p>

                                {/* Action Buttons */}
                                <div className="d-flex flex-wrap justify-content-center gap-3 mb-5">
                                    <Button as={Link} to="/" variant="danger" size="lg">
                                        <i className="ri-home-4-line me-2"></i> Back to Home
                                    </Button>

                                    <Button as="a" href="mailto:support@reshto.com" variant="dark" size="lg">
                                        <i className="ri-customer-service-line me-2"></i> Contact Support
                                    </Button>
                                </div>

                                {/* Status Info */}
                                <div className=" p-4 rounded-3 shadow-sm mb-4" style={{ maxWidth: '600px', margin: '0 auto' }}>
                                    <p className="text-muted mb-3">Current Service Status</p>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span>Website Status</span>
                                        <span className="badge bg-success">Operational</span>
                                    </div>
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <span>API Status</span>
                                        <span className="badge bg-danger">Experiencing Issues</span>
                                    </div>
                                </div>

                                {/* Help Section */}
                                <div className="mt-5 pt-4 border-top">
                                    <p className="text-muted mb-4">Need immediate assistance?</p>
                                    <div className="d-flex flex-wrap justify-content-center gap-4">
                                        <a href="mailto:support@reshto.com" className="text-decoration-none">
                                            <i className="ri-mail-line me-2"></i> support@reshto.com
                                        </a>
                                        <span className="text-muted d-none d-md-inline">|</span>
                                        <a href="tel:+1234567890" className="text-decoration-none">
                                            <i className="ri-phone-line me-2"></i> +1 (234) 567-890
                                        </a>
                                    </div>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default ServerError;
